// Timer constants — centralise delay values so they're easy to tune.
export const MODAL_CLOSE_DELAY_MS = 1400; // pause after success animation before dismissing modal
export const TOAST_DURATION_MS    = 2000; // inline "saved" / "updated" feedback display duration

// Maps entry status → short badge key used in CSS classes and export HTML.
// Cancelled entries use "CANCELLED" regardless of .status value.
export const STATUS_EXPORT_KEY = {
  "PARTIAL SUCCESS":       "PARTIAL",
  "UNABLE TO CONFIRM":     "UNABLE",
  "PROTECTED":             "PROTECTED",
};
